import Header from "@/components/Header";
import Hero from "@/components/Hero";
import WhyThisExists from "@/components/WhyThisExists";
import ProblemSection from "@/components/ProblemSection";
import WhatWeDoSection from "@/components/WhatWeDoSection";
import BeforeAfterSection from "@/components/BeforeAfterSection";
import WhatMakesDifferent from "@/components/WhatMakesDifferent";
import WhoItsForSection from "@/components/WhoItsForSection";
import CredibilityLine from "@/components/CredibilityLine";
import ProcessSection from "@/components/ProcessSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <WhyThisExists />
        <ProblemSection />
        <WhatWeDoSection />
        <BeforeAfterSection />
        <WhatMakesDifferent />
        <WhoItsForSection />
        <CredibilityLine />
        <ProcessSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
